import { ListColumnTitle } from '@app-models/list-column-title';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import * as _ from 'lodash';
import { SortColumn } from '@app-models/sort-column';
import { BreakpointObserverService } from '@app-services/shared/breakpoint-observer.service';

export enum Sort {
  ASC = 'ascending',
  DESC = 'descending',
}

@Component({
  selector: 'app-list-column-title',
  templateUrl: './list-column-title.component.html',
  styleUrls: ['./list-column-title.component.scss'],
})
export class ListColumnTitleComponent implements OnInit, OnChanges {
  @Output() sortColumn = new EventEmitter<SortColumn>();

  @Input() columns: ListColumnTitle[];

  @Input() activeColumnSort: string;
  @Input() selectedSort: string;
  filter: string;

  isXSmall = false;
  isSmall = false;
  isMedium = false;
  isLarge = false;

  constructor(public breakpointObserver: BreakpointObserverService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.activeColumnSort) {
      this.activeColumnSort = changes.activeColumnSort.currentValue;
    }
    if (changes.selectedSort) {
      this.selectedSort = changes.selectedSort.currentValue;
    }
  }

  ngOnInit(): void {
    this.breakpointObserver.screenSizeObserver.subscribe((breakpoints) => {
      this.isXSmall = breakpoints.isXSmall;
      this.isSmall = breakpoints.isSmall;
      this.isMedium = breakpoints.isMedium;
      this.isLarge = breakpoints.isLarge;
    });
    const defaultColumnSort = _.takeWhile(this.columns, [
      'isDefaultSort',
      true,
    ]);
    if (_.size(defaultColumnSort)) {
      this.activeColumnSort = defaultColumnSort[0].sortField;
      this.selectedSort = Sort.ASC;
    }
  }

  calculateColumnsContainer() {
    let columns = [];
    if (this.isMedium || this.isLarge) {
      const filteredColumns = _.filter(
        this.columns,
        (item) => item.showIsDesktop
      );
      columns = _.map(filteredColumns, _.property('columnSizeDesktop'));
    }
    if (this.isSmall) {
      const filteredColumns = _.filter(
        this.columns,
        (item) => item.showIsTablet
      );
      columns = _.map(filteredColumns, _.property('columnSizeTablet'));
    }
    if (this.isXSmall) {
      const filteredColumns = _.filter(
        this.columns,
        (item) => item.showIsMobile
      );
      columns = _.map(filteredColumns, _.property('columnSizeMobile'));
    }
    const gridColumnTemplateArray = _.map(columns, (item) => {
      return item + 'fr';
    });
    const gridColumnTemplate = _.join(gridColumnTemplateArray, ' ');
    return {
      display: 'grid',
      'grid-template-columns': gridColumnTemplate,
    };
  }

  sort(column) {
    if (column.sortField === this.activeColumnSort) {
      switch (this.selectedSort) {
        case null:
          this.selectedSort = Sort.ASC;
          this.filter = column.ascSortField;
          break;
        case Sort.ASC:
          this.selectedSort = Sort.DESC;
          this.filter = column.descSortField;
          break;
        case Sort.DESC:
          this.selectedSort = null;
          this.filter = null;
          break;
      }
    } else {
      this.activeColumnSort = column.sortField;
      this.filter = column.ascSortField;
      this.selectedSort = Sort.ASC;
    }
    this.sortColumn.emit({
      column: this.activeColumnSort,
      sort: this.filter,
    });
  }

  showColumn(column: ListColumnTitle) {
    if (
      (this.isLarge || this.isMedium) &&
      column.showIsDesktop &&
      column.columnSizeDesktop > 0
    ) {
      return true;
    } else if (
      this.isSmall &&
      column.showIsTablet &&
      column.columnSizeTablet > 0
    ) {
      return true;
    } else {
      return (
        this.isXSmall && column.showIsMobile && column.columnSizeMobile > 0
      );
    }
  }
}
